export default __webpack_public_path__ + "static/media/objects-thinking-extraversion.a57cd00a.png";